<template>
  <tr>
    <td><router-link :to="`/orders/${label.order_id}?label=${label.id}`"><button class="btn btn-app btn-info"><i class="fa fa-reply"></i>{{'order' | translate}}</button></router-link></td>
    <td class="small">{{label.created_at | orderDate}}<br><span class="text-muted"><i class="fa fa-clock-o mr-5"></i>{{label.created_at | orderDate(true)}}</span></td>
    <td>
      <div v-for="message in messages" @click="$emit('payload', label.payload)" class="alert alert-danger" style="margin-bottom: 5px !important">
        <span><i class="fa fa-exclamation-triangle mr-5"></i>{{message}}</span>
      </div>
    <td>{{label.status}}</td>
    <td class="text-center"><button class="btn btn-sm btn-info no-margin" :disabled="disabled" @click="retry(label)"><i :class="['fa fa-refresh', disabled ? 'fa-spin' : '' ]"></i></button></td>
    <td class="text-center">
      <a href="#" @click="correct(label)" :disabled="disabled" class="btn btn-primary btn-sm no-margin"  data-toggle="modal" data-target="#edit-modal"><i class="fa fa-truck"></i></a></td>
  </tr>
</template>
<script>
  export default {
    props: ['label', 'index', 'messages'],
    data () {
      return {
        disabled: false
      }
    },
    methods: {
      retry (label) {
        this.disabled = true
        API.put(`observation/labels/failed/${label.id}`)
          .then(response => {
            if (response.status === 304) {
              this.update('Sorry! the label is already being processed. Please wait and retry later if necessary')
            } else {
              this.$store.commit('pushAlert', {dismiss: 4, type: 'success', message: 'Das Label wird erneut bearbeitet', icon: 'fa fa-check', show: true})
              this.disabled = false
              this.$emit('remove', label)
            }
          })
          .catch(error => {
            this.$store.commit('pushAlert', {dismiss: 4, type: 'danger', message: error, icon: 'fa fa-ban', show: true})
          })
      },
      correct (label) {
        this.disabled = true
        this.$emit('clearError')
        API.get(`orders/${label.order_id}/customer/shipping`)
          .then(response => {
            this.$emit('correct', {data: response.data, id: label.order_id})
            this.disabled = false
          })
        .catch(error => {
          this.$emit('error', {error: error})
        })
      }
    },
    watch: {
      label () {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/tools/TableRows/LabelRow.vue